/**
 * @generated SignedSource<<8e3890fb2f766854e00a6c3786af540d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getProviderOrganizationQuery$variables = {
  id?: number | null;
};
export type getProviderOrganizationQuery$data = {
  readonly sys_providers: ReadonlyArray<{
    readonly organization_id: number;
  }>;
};
export type getProviderOrganizationQuery = {
  response: getProviderOrganizationQuery$data;
  variables: getProviderOrganizationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 1
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "provider_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_providers",
    "kind": "LinkedField",
    "name": "sys_providers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organization_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getProviderOrganizationQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getProviderOrganizationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "37382d4bb9211248af332542ca56bac3",
    "id": null,
    "metadata": {},
    "name": "getProviderOrganizationQuery",
    "operationKind": "query",
    "text": "query getProviderOrganizationQuery(\n  $id: Int\n) {\n  sys_providers(limit: 1, where: {provider_id: {_eq: $id}}) {\n    organization_id\n  }\n}\n"
  }
};
})();

(node as any).hash = "795dced88dfcde2fa83ee4e779e9a255";

export default node;
